import useLocalStore from '../../../../hooks/use-local-store';

const PrintFooter = ({
  propriedade,
  safra,
  atividade,
  userRecomendante,
}: FooterProps) => {
  const user = useLocalStore('user');
  const recomendante = userRecomendante ?? user.value?.nome_completo;

  return (
    <div className="pt-5 px-5">
      <span>
        <strong>Propriedade: </strong>
      </span>
      <span>{propriedade}</span>
      <br />
      <span>
        <strong>Safra: </strong>
      </span>
      <span>{safra}</span>
      <br />
      <span>
        <strong>Atividade: </strong>
      </span>
      <span>{atividade}</span>

      <div className="print-footer-rubric-container">
        <div className="print-footer-rubric">
          <p>_____________________________</p>
          <span>{recomendante}</span>
          <br />
          <span>
            <strong>Recomendante</strong>
          </span>
        </div>
        <div className="print-footer-rubric">
          <p>_____________________________</p>
          <p>
            <strong>Responsável</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export interface FooterProps {
  propriedade?: string;
  safra?: string;
  atividade?: string;
  userRecomendante?: string;
}

export default PrintFooter;
